import { render } from "./FormBuilderList.vue?vue&type=template&id=0b09e43e"
import script from "./FormBuilderList.vue?vue&type=script&lang=js"
export * from "./FormBuilderList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__